// Environment detection utility
const getEnvironment = (): 'development' | 'production' => {
  const hostname = typeof window !== 'undefined' ? window.location.hostname : 'localhost';
  
  // Local development
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    return 'development';
  }
  
  // Development subdomain
  if (hostname === 'www.dev.intelyx.ai') {
    return 'development';
  }
  
  // Production domain
  if (hostname === 'www.intelyx.ai') {
    return 'production';
  }
  
  // Default to development for any other case
  return 'development';
};

// Environment-specific API endpoints
const API_ENDPOINTS = {
  development: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://4cb56mft5e.execute-api.us-east-1.amazonaws.com/dev',
    contactForm: process.env.REACT_APP_CONTACT_API_URL || 'https://4cb56mft5e.execute-api.us-east-1.amazonaws.com/dev/contact-us'
  },
  production: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'https://api.intelyx.ai/prod',
    contactForm: process.env.REACT_APP_CONTACT_API_URL || 'https://api.intelyx.ai/prod/contact-us'
  }
};

// Get current environment
const currentEnvironment = getEnvironment();
const currentEndpoints = API_ENDPOINTS[currentEnvironment];

// API Configuration for Intelyx AI Contact Form
export const API_CONFIG = {
  // Environment-aware endpoint
  CONTACT_FORM_ENDPOINT: currentEndpoints.contactForm,
  
  // Base API URL for future endpoints
  API_BASE_URL: currentEndpoints.baseUrl,
  
  // Current environment
  ENVIRONMENT: currentEnvironment,
  
  // Timeout settings
  REQUEST_TIMEOUT: 30000, // 30 seconds
  
  // Rate limiting (client-side)
  MIN_SUBMIT_INTERVAL: 5000, // 5 seconds between submissions
  
  // Environment-specific settings
  IS_DEVELOPMENT: currentEnvironment === 'development',
  IS_PRODUCTION: currentEnvironment === 'production',
};